import React from 'react';
import { g_HttpReq } from '../utils/httpUtils';

const assetsPrefix = process.env.NODE_ENV === 'development' || process.env.DEBUG_BUILD === 'true' ? '/apiassets' : '/assets';

class apiCsv {
  // New APIs using filters - used in Tables
  async apiAssetsGetCsv(props = {}) {
    const { entityName, filters = [] } = props;
    const requestedParamsMap = {
      Health: ['healthInfo', 'telemetryInfo', 'locationInfo'],
      Vehicles: ['telemetryInfo'],
      Faultcodes: ['healthInfo', 'telemetryInfo'],
    };
    const reqProps = { entityName };

    const mergedFilters = [...filters, ...(entityName === 'Faultcodes' ? [{ id: 'withDTC', value: true }] : [])];

    reqProps.filters = JSON.stringify(mergedFilters);
    reqProps.extraFields = requestedParamsMap[entityName] || [];

    return g_HttpReq.fetchGetCsv(`${assetsPrefix}/csv`, reqProps);
  }

  async apiAlertsGetCsv(props = {}) {
    const { entityName } = props;
    const reqProps = { entityName };
    return g_HttpReq.fetchGetCsv('/alerts/csv', reqProps);
  }

  async apiAlertsLogGetCsv(props = {}) {
    const { entityName, tzInfo, filters = [] } = props;
    const reqProps = { entityName, ...(tzInfo && { tzIana: tzInfo.iana }), filters: JSON.stringify(filters) };
    return g_HttpReq.fetchGetCsv('/alerts/log/csv', reqProps);
  }

  async apiBillingLogGetCsv(props = {}) {
    const { entityName, filters = [] } = props;
    const reqProps = { entityName, filters: JSON.stringify(filters) };
    return g_HttpReq.fetchGetCsv('/admin/billinglog/csv', reqProps);
  }

  async apiBillingSummaryGetCsv(props = {}) {
    const { entityName, filters = [] } = props;
    const reqProps = { entityName, filters: JSON.stringify(filters) };
    return g_HttpReq.fetchGetCsv('/admin/billingsummary/csv', reqProps);
  }

  async apiAuditLogGetCsv(props = {}) {
    const { entityName, filters = [] } = props;
    const reqProps = { entityName, filters: JSON.stringify(filters) };
    return g_HttpReq.fetchGetCsv('/admin/auditlog/csv', reqProps);
  }

  async apiServicesLogGetCsv(props = {}) {
    const { entityName, filters = [] } = props;
    const reqProps = { entityName, filters: JSON.stringify(filters) };
    return g_HttpReq.fetchGetCsv('/admin/serviceslog/csv', reqProps);
  }

  async apiDriversGetCsv(props = {}) {
    const { entityName, filters = [] } = props;
    const reqProps = { entityName, filters: JSON.stringify(filters) };
    return g_HttpReq.fetchGetCsv('/drivers/csv', reqProps);
  }

  async apiDriverCheckInsGetCsv(props = {}) {
    const { entityName, tzInfo, filters = [] } = props;
    const reqProps = { entityName, ...(tzInfo && { tzIana: tzInfo.iana }), filters: JSON.stringify(filters) };
    return g_HttpReq.fetchGetCsv('/drivers/checkins/csv', reqProps);
  }

  async apiFaultCodesGetCsv(props = {}) {
    const { entityName, tzInfo, filters = [] } = props;
    const reqProps = { entityName, ...(tzInfo && { tzIana: tzInfo.iana }), filters: JSON.stringify(filters) };
    return g_HttpReq.fetchGetCsv('/maintenance/faultcodes/csv', reqProps);
  }

  async apiFleetsGetCsv(props = {}) {
    return g_HttpReq.fetchGetCsv('/fleets/csv', props);
  }

  async getGeoFenceReportGetCsv(props = {}) {
    const { entityName, tzInfo, filters = [] } = props;
    const reqProps = { entityName, ...(tzInfo && { tzIana: tzInfo.iana }), filters: JSON.stringify(filters) };
    return g_HttpReq.fetchGetCsv('/system/geofence-report/csv', reqProps);
  }

  async apiIdlingEventsGetCsv(props = {}) {
    const { entityName, tzInfo, filters = [] } = props;
    const reqProps = { entityName, ...(tzInfo && { tzIana: tzInfo.iana }), filters: JSON.stringify(filters) };
    return g_HttpReq.fetchGetCsv('/trips/idlingEventsReports/csv', reqProps);
  }

  async apiResellersGetCsv(props = {}) {
    return g_HttpReq.fetchGetCsv('/resellers/csv', props);
  }

  async apiSafetyEventsGetCsv(props = {}) {
    const { entityName, entityType, filters = [] } = props;
    const reqProps = { entityName, entityType, filters: JSON.stringify(filters) };
    return g_HttpReq.fetchGetCsv('/safety/csv/events', reqProps);
  }

  async apiTagsGetCsv(props = {}) {
    return g_HttpReq.fetchGetCsv('/tags/csv', props);
  }

  async apiTripsGetCsv(props = {}) {
    const { entityName, tzInfo, filters = [] } = props;
    const reqProps = { entityName, ...(tzInfo && { tzIana: tzInfo.iana }), filters: JSON.stringify(filters) };
    return g_HttpReq.fetchGetCsv('/trips/csv', reqProps);
  }

  async apiIFTAGetCsv(props = {}) {
    const { entityName, filters = [] } = props;
    const reqProps = { entityName, filters: JSON.stringify(filters) };
    return g_HttpReq.fetchGetCsv('/fleets/reports/ifta/csv', reqProps);
  }

  async apiUserGetCsv(props = {}) {
    return g_HttpReq.fetchGetCsv('/users/csv', props);
  }

  // OLD APIs - Used in Tables
  async apiDriverPerformanceGetCsv(props = {}) {
    const { entityName, tags, dateRange } = props;
    const reqProps = {
      entityName,
      ...(tags && Array.isArray(tags) && tags.length > 0 && { tags }),
      startTime: dateRange?.from,
      endTime: dateRange?.to,
    };
    return g_HttpReq.fetchGetCsv('/safety/driver/csv', reqProps);
  }

  async apiVehiclePerformanceGetCsv(props = {}) {
    const { entityName, tags, dateRange } = props;
    const reqProps = {
      entityName,
      ...(tags && Array.isArray(tags) && tags.length > 0 && { tags }),
      startTime: dateRange?.from,
      endTime: dateRange?.to,
    };
    return g_HttpReq.fetchGetCsv('/safety/csv/vehiclePerformance', reqProps);
  }

  async apiVehicleIdlingEventsGetCsv(props = {}) {
    const { entityName, dateRange, tags } = props;
    const reqProps = {
      entityName,
      startTime: dateRange?.from,
      endTime: dateRange?.to,
      ...(tags && Array.isArray(tags) && tags.length > 0 && { tags }),
    };
    return g_HttpReq.fetchGetCsv('/trips/vehicleIdlingEventsReport/csv', reqProps);
  }

  async apiCsvGetVehicleActivity(props = {}) {
    const { entityName, dateRange, tags } = props;
    const reqProps = {
      entityName,
      startTime: dateRange?.from,
      endTime: dateRange?.to,
      ...(tags && Array.isArray(tags) && tags.length > 0 && { tags }),
    };
    return g_HttpReq.fetchGetCsv(`${assetsPrefix}/asset-activity-report/csv`, reqProps);
  }

  async apiCsvGetGpsLog(props = {}) {
    const { entityName, dateRange, imei, fleetName } = props;
    const startDate = dateRange?.from.toISOString() ?? new Date('1/1/2024').toISOString();
    const endDate = dateRange?.to.toISOString() ?? new Date().toISOString();

    const reqProps = {
      entityName,
      startDate,
      endDate,
      ...(imei && { imei }),
      ...(fleetName && { fleetName }),
    };
    return g_HttpReq.fetchGetCsv('/admin/gpsLog/csv', reqProps);
  }

  async apiCsvGetMaintenance(props = {}) {
    const { entityName, tabIndex, tzInfo } = props;
    const reqProps = {
      tabIndex,
      entityName,
      ...(tzInfo && { tzIana: tzInfo.iana }),
    };
    return g_HttpReq.fetchGetCsv('/maintenance/csv', reqProps);
  }

  async apiInstalledAssetsGetCsv(props = {}) {
    const { entityName, dateRange } = props;
    const startTime = dateRange?.from.toISOString() ?? new Date('1/1/2024').toISOString();
    const endTime = dateRange?.to.toISOString() ?? new Date().toISOString();
    const reqProps = {
      entityName,
      startTime,
      endTime,
    };
    return g_HttpReq.fetchGetCsv(`${assetsPrefix}/installed-assets/csv`, reqProps);
  }

  async apiCsvGetDvir(props = {}) {
    const { entityName, tabIndex, tzInfo } = props;
    const reqProps = {
      tabIndex,
      entityName,
      ...(tzInfo && { tzIana: tzInfo.iana }),
    };
    return g_HttpReq.fetchGetCsv('/dvir/csv', reqProps);
  }

  // OLD APIs - Not Used in Tables
  async apiCsvGetFences(props = {}) {
    props.entityName = 'GeoFences';
    return g_HttpReq.fetchGetCsv('/system/geozones/csv', props);
  }
}

const g_apiCsv = new apiCsv();
export default g_apiCsv;
